import React from 'react';
import { X } from 'lucide-react';
import { formatDateTime } from '../utils/dateFormat';

interface HistoryEntry {
  id: string;
  doctor_id: string;
  changed_at: string;
  changes: {
    diagnostic?: string;
    epicriza?: string;
    recomandari?: string;
    notes4doctor?: string;
  };
  profiles: {
    prenume: string;
    nume: string;
  };
}

interface HistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  history: HistoryEntry[];
  fieldName: string;
  onRestore?: (fieldName: string, content: string) => void;
}

export default function HistoryModal({ isOpen, onClose, history, fieldName, onRestore }: HistoryModalProps) {
  if (!isOpen) return null;

  const getFieldLabel = (field: string) => {
    switch (field) {
      case 'diagnostic': return 'Diagnostic';
      case 'epicriza': return 'Epicriză';
      case 'recomandari': return 'Recomandări';
      case 'notes4doctor': return 'Note pentru medic';
      default: return field;
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        <div className="p-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold text-gray-900">
              Istoric modificări - {getFieldLabel(fieldName)}
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {history.length > 0 ? (
            <div className="space-y-4">
              {history.map((entry) => (
                <div key={entry.id} className="bg-gray-50 rounded-lg p-4">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <p className="text-sm text-gray-600">
                        Modificat de {entry.profiles?.prenume || 'Unknown'} {entry.profiles?.nume || 'Doctor'}
                      </p>
                      <p className="text-xs text-gray-500">
                        {formatDateTime(entry.changed_at)}
                      </p>
                    </div>
                    {onRestore && (
                      <button
                        onClick={() => {
                          const content = entry.changes[fieldName as keyof typeof entry.changes];
                          if (content) {
                            onRestore(fieldName, content);
                          }
                        }}
                        className="px-3 py-1 bg-[#007FFF] text-white text-sm rounded hover:bg-[#024994] transition"
                      >
                        Restaurează conținut
                      </button>
                    )}
                  </div>
                  <div className="mt-2 whitespace-pre-wrap text-gray-700">
                    {entry.changes[fieldName as keyof typeof entry.changes]}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-600">
              Nu există modificări înregistrate pentru acest câmp.
            </p>
          )}
        </div>

        <div className="p-4 border-t border-gray-200">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
            >
              Închide
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
